module.exports = __webpack_public_path__ + "static/media/TampleShalom.c981f042.svg";